import React, { Fragment, useState } from 'react';
import Header3 from '../../components/header3/Header3';
import Scrollbar from '../../components/scrollbar/scrollbar'
import ProjectHero from '../../components/hero3/projecthero';
import BusinessContact from '../../components/business-consulting-components/BusinessContact/BusinessContact';
import BusinessFooter from '../../components/business-consulting-components/BusinessFooter/BusinessFooter';
import Video from '../../images/Video.png';
import ToolSection from '../../components/business-consulting-components/ToolSection';
import ClientNumber from '../../components/business-consulting-components/clientnumber';
import srj1 from '../../images/myhotel1.png'
import srj2 from '../../images/srj2.svg'
import srj3 from '../../images/myhotel3.png'
import srj7 from '../../images/myhotel7.png'
import srj8 from '../../images/srj8.png'
import srj9 from '../../images/srj9.png'
import srj10 from '../../images/myhotel10.png'
import CaseStudiesSlider from '../../components/business-consulting-components/CaseStudiesSlider';



const EaseMyHotel = (props) => {

    const [isOpen, setOpen] = useState(false)
    return (
        <Fragment>
           <div className='index_business_consulting'>
                <main className="page_content s2">
                    <Header3 />
                    <ProjectHero top_title={<>Organic Growth & CAC Reduction for Ease My Hotel (SaaS)</>}/>

                    <section className="video_section">
                        <div className="container text-center project_page_desp">
                            <h2>Company Overview</h2>

                            <ul className='project_page_ul'>
                                <li>
                                    <span className='number_css'>15+</span>
                                    <span className='hero_bottom_text'>Team Size</span>
                                </li>
                                <li>
                                    <span className='number_css'>India</span>
                                    <span className='hero_bottom_text'>Country</span>
                                </li>
                                <li>
                                    <span className='number_css'>Saas</span>
                                    <span className='hero_bottom_text'>Industry</span>
                                </li>
                                <li>
                                    <span className='number_css'>Hotel & Resort Management Platform</span>
                                    <span className='hero_bottom_text'>Category</span>
                                </li>
                            </ul> 
                        </div>
                    </section>

                    <section className="intro_about_section section_space">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <h2>About Business</h2>
                                    <p className='heading_description text-dark mb-0'>Anzar is the Marketing Head at Ease My Hotel <br/> (EMH), a hotel and resort management platform <br/> built for independent hotels, boutique resorts, and <br/> multi-property groups. EMH centralizes front office, <br/> reservations, housekeeping, POS, inventory, and <br/> OTA/channel distribution to improve occupancy, <br/> ADR, and RevPAR through a single operating <br/> system.</p>
                                </div>

                                <div className="col-lg-6" style={{textAlign:'right'}}>
                                    <img src={srj1} alt="srj1" style={{maxWidth:'60%'}}/>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="intro_about_section section_space pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <img src={srj2} alt="aiseo" className='img-fluid' style={{maxWidth:'60%'}}/>
                                </div>

                                <div className="col-lg-6">
                                    <h2>Client Challenges</h2>
                                    <p className='heading_description text-dark mb-0'>Before partnering with us, EMH faced critical growth barriers:</p>
                                    <ul class="srj_list mt-4 ">
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>High CAC in a saturated “Hotel Management Software/Hotel ERP” market dominated by established players.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Low organic visibility for core commercial queries (e.g., hotel PMS, channel manager, booking engine).</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Fragmented messaging across feature pages with limited case studies and use-case depth.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Limited presence in AI search (Google AI Overviews/SGE, Bing AI, Perplexity), where many B2B software evaluations now begin.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="intro_about_section section_space max_900 pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <h2>Project Overview</h2>
                                    <h3 className='mt-4'>SEO Brief</h3>
                                    <p className='heading_description text-dark mb-0'>During onboarding, Anzar’s priority was clear: build durable brand presence in the hotel management software category and reduce CAC by leaning on organic growth—not paid ads. He wanted an expert partner to own SEO and growth content so his team could stay focused on business development.</p>
                                    
                                     <h3 className='mt-4'>Client Ask</h3>
                                      <ul class="srj_list mt-4 ">
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Create a sustainable, long-term SEO strategy (not a short-term spike).</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Prioritize organic growth; avoid paid advertising.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Leverage AI SEO (AEO/GEO) to appear in AI Overviews/answer engines for category terms and high-intent questions.</li>
                                    </ul>


                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="intro_about_section max_900 section_space pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <img src={srj3} alt="srj3" className='img-fluid' />
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="intro_about_section section_space pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 text-center">
                                    <img src={srj7} alt="srj3" className='img-fluid' />
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="intro_about_section section_space pt-0">
                        <div className="container">
                            <div className="row challenges_css">
                                <div className="col-lg-6">
                                    <img src={srj8} alt="aiseo" className='img-fluid' style={{maxWidth:'70%',marginTop:'20%'}}/>
                                </div>

                                <div className="col-lg-6">
                                    <h2>Challenges We Faced</h2>
                                    <p className='heading_description text-dark mb-0'>While working on the Ease My Hotel there are following challenges we have faced:</p>
                                    <ul class="srj_list mt-4 ">
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Crowded SERPs with aggregator reviews (Capterra, G2), legacy incumbents, and high DR publishers.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Intent overlap between hospitality tech research (“what is a PMS?”) and purchase-stage queries (“best PMS for resorts in India”).</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Sparse proof assets (limited case studies, vertical stories, and data-backed outcomes).</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Inconsistent taxonomy across features/integrations affecting internal linking and crawl paths.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>No systematic approach to AI answers (schemas, concise definitions, structured Q&A), limiting SGE/AIO inclusion.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="intro_about_section section_space solution pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <h2>Solution Provided</h2>
                                </div>

                                <div className="col-lg-6">
                                    <ul class="srj_list solution_list mt-4">
                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Diagnosis & Audit</div>
                                                <p>Technical audit: indexation, CWV (INP/LCP), faceted URLs, canonicals, pagination on listings, sitemap hygiene.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Demand & Gap Mapping</div>
                                                <p>Clustered “hotel PMS / hotel ERP / channel manager / booking engine/resort software / multi-property PMS” with commercial vs. informational intent splits.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>AI Visibility Audit</div>
                                                <p>Identified answerable questions and schema gaps to qualify for AI Overviews/answer engines.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Content & Category Authority Strategy</div>
                                                <p>Created Pillar–cluster architecture for Ease My Hotel, which helped in building topical authority. </p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>AI SEO (Answer Engine Optimization & Generative Engine Optimization)</div>
                                                <p>Structured Q&A blocks and concise definitions for hospitality terms (PMS, channel mix, parity, overbooking control). Set up Schema for Organization, SoftwareApplication, FAQ, HowTo, Breadcrumb, Review (policy-compliant), Product.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>On-Page & Experience</div>
                                                <p>Intent-aligned templates with modular CTAs (Demo, ROI Calculator, Download Checklist) and trust modules (security, uptime, certifications).</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Backlink, PR & Ecosystem</div>
                                                <p>Build high-quality backlinks on high DA/PA sites. Hospitality publications & associations contributed articles, expert quotes, and vendor listings.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Email & Nurture </div>
                                                <p>We have created email marketing campaigns that include lead warm-up, sign-up drop-off, and weekly newsletters to nurture and build engagement. </p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Conversion Rate Optimization (CRO)</div>
                                                <p>We have optimized the landing pages for UX and optimized RFQ/demo forms with qualification gates (rooms, property type, integrations needed).</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Analytics & Ops</div>
                                                <p>We made sure we track everything so that we can avoid the guesswork. For this, we were tracking website UX and user journey, website engagement using heatmaps, Google SERP keyword tracking, and AI Brand mention tracking, etc.</p>
                                            </div>
                                        </li>



                                    </ul>
                                </div>
                            </div>
                        </div>
                    </section>

                    <ToolSection title1={<>Want to reduce CAC and grow demos for your SaaS? </>} title2={<>Let’s build your AI-ready SEO engine.</>} />
                    
                    <section className="intro_about_section section_space project_outcome pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <h2>Project Outcome</h2>
                                </div>

                                <div className="col-lg-10 offset-lg-2">
                                    <ul class="srj_list solution_list mt-4">

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Increased Website Organic Traffic</div>
                                                <p>Increased category visibility for commercial clusters (PMS, channel manager, booking engine, resort software).</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Lower Customer Acquisition Cost (CAC)</div>
                                                <p>Lower CAC from organic as demo volume shifts from paid-heavy to content-led discovery.</p>
                                            </div>
                                        </li>

                                         <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Warm & Qualified Leads</div>
                                                <p>Qualified demo pipeline from hotels and resorts (multi-property and boutique segments).</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Increased AI Presence</div>
                                                <p>Presence in AI answers for targeted operational queries (implementation, OTA control, housekeeping workflows).</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Stronger Topical Authority </div>
                                                <p>Stronger authority graph via hospitality publications, directories, and integration partners.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Scalable Content Engine</div>
                                                <p>Repeatable content engine with roadmap and governance to sustain growth.</p>
                                            </div>
                                        </li>




                                    </ul>
                                </div>
                            </div>                            
                        </div>
                    </section>
                    <ClientNumber/>

                    <section className="intro_about_section section_space project_outcome">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 text-center">
                                    <img src={srj10} alt="srj10" className='img-fluid' />
                                </div>
                            </div>                            
                        </div>
                    </section>

                    <section className="intro_about_section section_space pt-0">
                        <div className="container max_900">
                            <div className="row">
                                <div className="col-lg-12 text-center tool_section_new">
                                    <h2>Partner with us and get your custom AI SEO <br/> strategy for your business</h2>
                                    <button className="read_more btn btn-secondary">Contact Now</button>
                                </div>
                            </div>                            
                        </div>
                    </section>

                    <CaseStudiesSlider/>
                    <BusinessContact />
                    <BusinessFooter />
                    <Scrollbar />
                </main>
            </div>
        </Fragment>
    )
};
export default EaseMyHotel;
